import script from "./ShoppingAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingAddress.vue?vue&type=script&setup=true&lang=js"

import "./ShoppingAddress.vue?vue&type=style&index=0&id=3bc29cb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc29cb2"]])

export default __exports__